import { type TimezoneName, getTimezone } from 'countries-and-timezones';
import { format } from 'date-fns';
import { toDate } from 'date-fns-tz';

export const toDateInTimezone = (
  date: Date | string,
  timeZone: TimezoneName
) => {
  const datestring = format(date, "yyyy-MM-dd'T'HH:mm:ss");
  const zonedDate = toDate(datestring, { timeZone });
  return zonedDate;
};

export const isTimezoneEqualToLocal = (timezone: TimezoneName) => {
  const tz = getTimezone(timezone);
  const local_tz = getTimezone(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  if (!tz || !local_tz) {
    return false;
  }

  return tz.utcOffset === local_tz.utcOffset;
};
